import { useCallback, useMemo } from 'react';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import type { GoToTest } from '../types';
import { CellContainer, CellTypography } from '../components/FlowsGrid.styles';
import { useListParams } from 'hooks';
import { IconButton, Typography } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useGoToTestColumns = (): GridColDef[] => {
  const { desc, setDesc, setOrderBy } = useListParams();

  const handleOrderBy = useCallback(() => {
    setDesc(!desc);
    setOrderBy('floqw_name');
  }, [desc, setDesc, setOrderBy]);

  return useMemo(
    () => [
      {
        field: 'flow.name',
        headerName: 'Flow for testing',
        width: 420,
        sortable: false,
        renderHeader: () => {
          return (
            <CellContainer sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant={'subtitle2'}>Flow for testing</Typography>
              <IconButton
                sx={{ p: 0.5, transform: `rotate(${desc ? 0 : 180}deg)` }}
                onClick={handleOrderBy}
              >
                <ArrowUpward sx={{ fontSize: 16 }} />
              </IconButton>
            </CellContainer>
          );
        },
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest).flow.name}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'ad_account.name',
        headerName: 'Account name for testing',
        width: 320,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest).ad_account.name}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'ad_account.ad_account_id',
        headerName: 'Account ID for testing',
        width: 320,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as GoToTest).ad_account.ad_account_id}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
    ],
    [handleOrderBy, desc],
  );
};
